/*
* Section Panelized showing three radios buttons and less options for spacing and rails
* Individual, Tab Routed panels or V Scored panels
*/
import React from 'react';
import { Collapse } from 'react-bootstrap';

import Panelized from 'pu-react/components/Panelized';
import YesPanelized from 'pu-react/components/SectionYesPanelized';
import HiddenInput from 'pu-react/components/HiddenInput';

import HasArray from './HasArrayITV';
import NoPanelized from './SectionNoPanelizedTV';

function SectionPanelized(props) {
  const { parameters } = props;
  return (
    <div className="array-need">
      <HasArray {...props} />
      <Collapse in={parameters.has_array === '1'}>
        <div>
          <div className="array-fields">
            <Panelized {...props} />
            <Collapse in={parameters.is_panelized === '1'}>
              <div className="yes-panelized">
                <YesPanelized {...props} />
              </div>
            </Collapse>
            <Collapse in={parameters.is_panelized === '0'}>
              <div className="no-panelized">
                <NoPanelized {...props} />
              </div>
            </Collapse>
            <HiddenInput
              name="tab_rout"
              value={parameters.tab_rout}
              groupName={props.groupName} />
            <HiddenInput
              name="scoring"
              value={parameters.scoring}
              groupName={props.groupName} />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default SectionPanelized;
